module.exports = __webpack_public_path__ + "static/img/LANCASTER_PAINT.8e0158f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LANCASTER_PAINT.jpg
// module id = +V2l
// module chunks = 0